import React from 'react';
import { faListUl, faCircle } from '@fortawesome/pro-solid-svg-icons';
import { node, shape, string } from 'prop-types';
import { faBook } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Card, Divider } from 'antd';
import { isEqual, map } from 'lodash';
import FroalaEditorView from 'Src/common/components/froalaEditor/froalaEditorView';

import './style.scss';

function MentorshipDetailCard({ data, type, title }) {
  const isFroala = isEqual(type, 'froala');

  return (
    <div className="services-offered-wrapper mt16">
      <Card>
        <div className="title-wrapper arc-d-flex">
          <FontAwesomeIcon icon={isFroala ? faBook : faListUl} />
          <h3 className="arc-H150 arc-font-weight-bold-imp ml12 mb0">{title}</h3>
        </div>
        <Divider />
        <Choose>
          <When condition={isFroala}>
            <If condition={data}>
              <div className="mentorship-description-content">
                <FroalaEditorView model={data} />
              </div>
            </If>
          </When>
          <Otherwise>
            <ul className="services-wrapper">
              {map(data, (service) => (
                <li key={service.id || service.name} className="arc-p arc-d-flex arc-flex-vertical-align">
                  <FontAwesomeIcon icon={faCircle} className="list-circle mr6" />
                  {service.name}
                </li>
              ))}
            </ul>
          </Otherwise>
        </Choose>
      </Card>
    </div>
  );
}

MentorshipDetailCard.propTypes = {
  data: shape().isRequired,
  title: node.isRequired,
  type: string.isRequired,
};

export default MentorshipDetailCard;
